import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  CASH_FLOW_TABS,
  cashFlowInitialValues,
} from 'components/organisms/forms/cash-flow/CashFlowForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostIncome, usePutIncomeFile } from 'services/cash-flow/income';
import { ICashFlowForm } from 'services/cash-flow/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateIncome = () => {
  const labelId = useCustomParamId('id', '/label');

  const { pathname } = useLocation();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const createIncome = usePostIncome();

  const mutateOptions = useMutateOptions<ICashFlowForm>();

  const addFile = usePutIncomeFile();

  const onGoToDetail = (id: string) =>
    navigate(`/label/${labelId}/income/${id}/${getLastPathname(pathname)}`);

  const addFileToIncome = async (file: File, id: string) => {
    await addFile.mutateAsync(
      { file, id },
      {
        onSuccess: () => onGoToDetail(id),
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  const onCreateIncome = async (
    values: ICashFlowForm,
    helpers: FormikHelpers<ICashFlowForm>
  ) => {
    await createIncome.mutateAsync(
      { ...middleware.income.formToQuery(values), labelId: labelId },
      {
        ...mutateOptions(helpers),
        onSuccess: id =>
          values.file ? addFileToIncome(values.file, id) : onGoToDetail(id),
      }
    );
  };

  return (
    <Form.CashFlow
      initialValues={cashFlowInitialValues}
      onSubmit={onCreateIncome}
      disableTabs={[CASH_FLOW_TABS.repayments]}
      customBackItem={
        <Button onlyIcon onClick={() => navigate(`/label/${labelId}/balance`)}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
        </Button>
      }
    />
  );
};

export default CreateIncome;
